export const organizationSetupStatuses = {
    NOT_STARTED: "",
    ONBOARDING: "ONBOARDING",
    ONBOARDING_APPROVED: "ONBOARDING_APPROVED",
    ONBOARDING_REJECTED: "ONBOARDING_REJECTED",
    CHANGE_REQUESTED: "CHANGE_REQUESTED",
    DRAFT: "DRAFT",
    APPROVAL_PENDING: "APPROVAL_PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    BLOCKCHAIN_SUBMITTED: "BLOCKCHAIN_SUBMITTED",
    PUBLISH_IN_PROGRESS: "PUBLISH_IN_PROGRESS",
    PUBLISHED: "PUBLISHED",
};
export const organizationSetupStatusesLable = {
    ONBOARDING: "Onboarding",
    ONBOARDING_APPROVED: "Onboarding approved",
    ONBOARDING_REJECTED: "Onboarding rejected",
    CHANGE_REQUESTED: "Change requested",
    DRAFT: "Draft",
    APPROVAL_PENDING: "Approval pending",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    BLOCKCHAIN_SUBMITTED: "Blockchain submitted",
    PUBLISH_IN_PROGRESS: "Publish in progress",
    PUBLISHED: "Published",
};

export const rejectedStatuses = [
    // organizationSetupStatuses.ONBOARDING,
    // organizationSetupStatuses.ONBOARDING_REJECTED,
    // organizationSetupStatuses.CHANGE_REQUESTED,
    // organizationSetupStatuses.APPROVAL_PENDING,
    // organizationSetupStatuses.REJECTED,
];

export const addressTypes = {
    HEAD_QUARTERS: "headquarters_address",
    MAILING: "mailing_address",
};

export const orgSubmitActions = {
    SUBMIT: "SUBMIT",
    DRAFT: "DRAFT",
};

export const organizationTypes = {
    INDIVIDUAL: "individual",
    ORGANIZATION: "organization",
};
